<template>
  <Modal
    :headline="$t('myVocabulary.newTopic')"
    :save-btn-disabled="!isValidNewTopic"
    :save-btn-name="$t('app.create')"
    :show-modal="showTopicModal"
    @save="createTopic"
    @cancel="showTopicModal = false">
    <v-row align="end">
      <v-col cols="12" class="py-0">
        <v-text-field
          autofocus
          :label="`${$t('myVocabulary.topic')} (${userLanguages.base.toUpperCase()})`"
          autocomplete="off"
          v-model="baseTopic" />
      </v-col>
      <v-col cols="6">
        <p>{{ $t('myVocabulary.chooseColor') }}</p>
      </v-col>
      <v-col cols="6" class="text-center">
        <ColorChooser :color.sync="color" />
      </v-col>
    </v-row>
    <v-btn
      slot="activator"
      block
      color="green"
      outlined
      @click="onOpenTopic">
      <v-icon left small>add</v-icon>
      {{ $t('app.new') }}
    </v-btn>
  </Modal>
</template>

<script>
import Modal from '@components/modal';
import { mapGetters } from 'vuex';
import snackbarMethods from '@/mixins/snackbar';
import ColorChooser from '@components/color_chooser';

export default {
  name: 'MvTopicCreator',
  components: {
    Modal,
    ColorChooser,
  },
  mixins: [snackbarMethods],
  props: {
    vocabularyListByLanguage: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    showTopicModal: false,
    showColorModal: false,
    baseTopic: '',
    color: 'blue',
  }),
  computed: {
    ...mapGetters('user', ['userLanguages']),

    isValidNewTopic() {
      return this.baseTopic.length > 0;
    },
  },
  methods: {
    onOpenTopic() {
      this.showTopicModal = true;
      this.baseTopic = '';
    },
    createTopic() {
      const topicExists = this._.find(this.vocabularyListByLanguage, { [this.baseLanguage]: this.baseTopic });
      if (topicExists) {
        this.setSnackbarError({ text: `${this.$t('myVocabulary.topicExist')}` });
        return;
      }

      this.$emit('create:topic', this.baseTopic, this.color);

      this.showTopicModal = false;
    },
  },
};
</script>
